import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AgFloatingFilterComponent } from '../ag-floating-filter.component';
import { GxInputDirective } from '../../../../directives/gxinput.directive';
import { LetDirective } from '@ngrx/component';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgStyle } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { ISimpleFilterModelType } from '../ag-text-floating-filter/ag-text-floating-filter.component';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-ag-date-time-floating-filter',
  imports: [
    GxInputDirective,
    LetDirective,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    MatSuffix,
    ReactiveFormsModule,
    TranslateModule,
    NgClass,
    MatTooltip,
    NgStyle,
  ],
  templateUrl: './ag-date-time-floating-filter.component.html',
  standalone: true,
  styleUrls: ['../ag-list-floating-filter/ag-list-floating-filter.component.scss',
              './ag-date-time-floating-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgDateTimeFloatingFilterComponent extends AgFloatingFilterComponent implements OnInit {

  columnResizedListener = () => this.cd.markForCheck();

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    // set timeout to give component time to render
    setTimeout(() => {
      // manual cd needed for correct el. size calculation in html template after component
      // initializes
      this.cd.markForCheck();
      // manual cd needed for correct el. size calculation in html template after column is resized
      this.params.api?.addEventListener('columnResized',
          this.columnResizedListener);
    });
    // remove event listener when component is destroyed
    this.componentDestroyed
        .pipe(take(1))
        .subscribe(() => {
          this.params.api
              .removeEventListener('columnResized', this.columnResizedListener)
        });
  }

  protected override getInitialReadOnly(): boolean {
    return true;
  }

  protected override getDefaultType(): ISimpleFilterModelType {
    return null;
  }

  protected override setFormControlValueFromParentFilterModel(filterModel: { from: string, to: string }) {
    this.params.parentFilterInstance(filterInstance => {
      if (filterInstance?.getModelAsString) {
        this.setFormControlValueProgrammatically(filterInstance?.getModelAsString(filterModel));
      } else {
        console.error('Missing getModelAsString on parent filter class');
      }
    });
  }

  resetParentFilter() {
    this.params.parentFilterInstance((instance: any) => {
      instance.onResetClick();
    });
  }
}
